var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg88(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000391119 9.47812C0.000391117 9.25313 0.07539 9.06562 0.225391 8.87812L8.70039 0.253125C9.03789 -0.084375 9.56289 -0.084375 9.90039 0.253125C10.2379 0.590625 10.2379 1.11563 9.90039 1.45313L2.06289 9.47812L9.97539 17.5031C10.3129 17.8406 10.3129 18.3656 9.97539 18.7031C9.63789 19.0406 9.11289 19.0406 8.77539 18.7031L0.30039 10.0781C0.11289 9.89062 0.000391122 9.70313 0.000391119 9.47812Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg88);
export default __webpack_public_path__ + "static/media/svg88.a2d9e36531022cf37441575ba19cbe9f.svg";
export { ForwardRef as ReactComponent };